import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "How long does the Visibility Check™ take?",
    a: "Approximately 5 minutes.",
  },
  {
    q: "Who should complete the assessment?",
    a: "Principals, assistant principals, activities directors, media specialists, technology coordinators, communications staff, and other school leaders.",
  },
  {
    q: "What does the assessment evaluate?",
    a: "The Visibility Check™ evaluates Student Recognition, School Communication, School Culture, Event & Program Promotion, and Staff Empowerment.",
  },
  {
    q: "Will I receive my results immediately?",
    a: "You will receive your Visibility Score™ immediately after completion. Your personalized Visibility Report™ will be delivered shortly afterward.",
  },
  {
    q: "Is there any cost?",
    a: "No. The Visibility Check™ is completely free.",
  },
  {
    q: "What happens after I complete the assessment?",
    a: "You will receive your Visibility Score™, your personalized Visibility Report™, the School Visibility Playbook™, and additional recommendations and resources.",
  },
];

export default function VCFAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      data-testid="vc-faq-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-12">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            FAQ
          </div>
          <h2
            data-testid="vc-faq-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            Common Questions
          </h2>
        </div>

        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                data-testid={`vc-faq-item-${i}`}
                className={`bg-white border rounded-2xl overflow-hidden transition-colors ${
                  isOpen ? "border-teal/40" : "border-slate-200"
                }`}
              >
                <button
                  data-testid={`vc-faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 hover:bg-slate-50/50 transition-colors"
                  aria-expanded={isOpen}
                >
                  <span className="font-serif text-base sm:text-lg font-bold text-navy leading-snug pr-2">
                    {f.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-teal flex-shrink-0 transition-transform ${
                      isOpen ? "rotate-180" : ""
                    }`}
                    strokeWidth={2.5}
                  />
                </button>
                {isOpen && (
                  <div className="px-6 pb-6 -mt-1">
                    <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
